import 'core-js/fn/object/assign'
import 'core-js/fn/string/ends-with'
import 'core-js/fn/string/starts-with'
import 'core-js/fn/string/includes'
import 'core-js/fn/array/includes'
import 'core-js/fn/array/find'
import 'core-js/fn/array/for-each'
import 'core-js/fn/array/from'
import 'nodelist-foreach-polyfill'
import 'core-js/fn/math/sign'
import 'core-js/fn/number/is-integer'
